import api from './api';
import { Inmueble, ProductSummary } from '../types/Inmueble';

export const inmuebleService = {
  getAll: () => api.get<Inmueble[]>('/inmuebles'),
  getById: (id: string) => api.get<Inmueble>(`/inmuebles/${id}`),
  create: (data: Inmueble) => api.post<Inmueble>('/inmuebles', data),
  update: (id: string, data: Inmueble) => api.put<Inmueble>(`/inmuebles/${id}`, data),
  delete: (id: string) => api.delete(`/inmuebles/${id}`),
};

export const allProductsService = {
  getAll: () => api.get<ProductSummary[]>('/products'),
};
